import queryString from 'query-string';
import { DataProvider, } from 'ra-core';
import fetchJson from './utils/fetchJson';
import { RESOURCE_MAP } from './ra-data-treeql-config';

const buildFilter = ([key, value]: [string, any], _index: number) => {
  console.log(key, value);
  let index = '';
  if ('search' === key) {
    return `search=${encodeURIComponent(value as string)}`
  } else if (-1 !== key.indexOf('::')) {
    let [key2, type] = key.split("::");
    if (typeof value === 'object') {
      console.log(value);
      return '';
    } else {
      return `filter${index}=${key2},${type},${[value].flat().map(v => encodeURIComponent(v as string)).join(",")}`
    }
  } else if (-1 !== key.indexOf('->')) {
    let [key2, type] = key.split("->");
    if (typeof value === 'object') {
      console.log(value);
      return '';
    } else {
      return `filter${index}=${key2}.${type},cs,${[value].flat().map(v => encodeURIComponent(v as string)).join(",")}`
    }
  } else if ((typeof value === "object") && (value !== null) && ((value as any).__filter)) {
    console.log(55);
    return `filter${index}=${key},${encodeURIComponent((value as any).__filter)}`;
  } else if (typeof value === 'object') {
    if (null === value) {
      console.log(59);
      return '';
    } else {
      console.log(61);
      return Object.entries(value).map(([key2, v]) => {
        return `filter${index}=${key},${key2},${encodeURIComponent(v as string)}`
        // return `filter${index}=${key}.${key2},cs,${encodeURIComponent(v as string)}`
      }).join('&')
    }
  } else if (key.endsWith('_id')) {
    return `filter${index}=${key},eq,${encodeURIComponent(value as string)}`
  }
  return `filter${index}=${key},cs,${encodeURIComponent(value as string)}`
}

export const _makeFilter = (resource: string, params: any) => {
  let tempFilter = params.filter
  if (params.filter['__mode']) {
    delete tempFilter['__mode'];
    return [...Object.entries(tempFilter), ...RESOURCE_MAP[resource] ?.filters ?? []]
      .map(buildFilter).join('&')
  }
  // console.log('ra-data-treeql 1', [...Object.entries(tempFilter), ...RESOURCE_MAP[resource] ?.filters ?? []]);
  return [...Object.entries(tempFilter), ...RESOURCE_MAP[resource] ?.filters ?? []]
    .map(buildFilter).join('&');
}

/**
 * Maps react-admin queries to a TreeQL powered REST API
 *
 * @see https://treeql.org
 *
 * @example
 *
 * getList          => GET http://my.api.url/records/posts?order=title,ASC&page=1,25
 * getOne           => GET http://my.api.url/records/posts/123
 * getMany          => GET http://my.api.url/records/posts?123,456,789
 * getManyReference => GET http://my.api.url/records/posts?filter=author_id,eq,345
 * update           => PUT http://my.api.url/records/posts/123
 * updateMany       => PUT http://my.api.url/records/posts/123,456,789
 * create           => POST http://my.api.url/records/posts/123
 * delete           => DELETE http://my.api.url/records/posts/123
 * deleteMany       => DELETE http://my.api.url/records/posts/123,456,789
 *
 * @example
 *
 * import * as React from "react";
 * import { Admin, Resource } from 'react-admin';
 * import treeqlProvider from 'ra-data-treeql';
 *
 * import { PostList } from './posts';
 *
 * const App = () => (
 *     <Admin dataProvider={treeqlProvider('http://my.api.url/')}>
 *         <Resource name="posts" list={PostList} />
 *     </Admin>
 * );
 *
 * export default App;
 */
const getDataProvider = function(apiUrl: string, httpClient = fetchJson): DataProvider {
  let _extra = {};

  let dp: DataProvider = {

    _setExtra: (newExtra: any) => {
      _extra = newExtra;
      return Promise.resolve({ data: {} });
    },

    getExtra: () => {
      return _extra;
    },

    getList: async (resource, params) => {
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;
      // console.log('getList', params);
      // @see https://github.com/mevdschee/php-crud-api#filters
      const filters = _makeFilter(resource, params);

      const query = {
        order: `${field},${order}`,
        page: `${page},${perPage}`,
      };
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;

      let extraOrder = '';
      if ('reg_no' === field) {
        extraOrder='order=approved,asc&'
      }

      const url = `${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}?${extraOrder}${queryString.stringify(query)}&${filters}`;
      // console.log([...Object.entries(params.filter), ...RESOURCE_MAP[resource] ?.filters ?? []], filters, url);
      const { json } = await httpClient(url);
      // console.log('getList', url, json, params);
      return ({
        data: json.records,
        total: json.results,
      });
    },

    getOne: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      const { json } = await httpClient(`${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.id}`);
      // console.log('getOne', resource, params, `${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.id}`);
      return ({ data: json });
    },

    getMany: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      const url = `${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.ids.map(x => (x as any).__filter ? (x as any).__filter.split(',')[1] : x).join(',')}`;
      // console.log('getMany', resource, params, url, params.ids.map(x => (x as any).__filter ? (x as any).__filter.split(',')[1] : x).join(','));
      const { json } = await httpClient(url);
      return ({ data: Array.isArray(json) ? json : [json] });
    },

    getManyReference: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      // console.log(params);
      const { page, perPage } = params.pagination;
      const { field, order } = params.sort;

      const filters = _makeFilter(resource, params);

      const query = {
        // filter: fetchUtils.flattenObject(params.filter),
        order: `${field},${order}`,
        page: `${page},${perPage}`,
      };
      const url = `${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}?${queryString.stringify(query)}&filter=${params.target},eq,${params.id}&${filters}`;

      const { json } = await httpClient(url);
      // console.log('getManyReference', url, json, params);
      return ({
        data: json.records,
        total: json.results,
      });
    },

    // TODO: update is not returning the record
    update: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      // console.log('update', params);
      await preRequest(params);
      delete (params as any).data.created;
      delete (params as any).data.createdBy;
      delete (params as any).data.updated;
      delete (params as any).data.updatedBy;
      await httpClient(`${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.id}`, {
        method: 'PUT',
        body: JSON.stringify(params.data),
      });
      const { json } = await httpClient(`${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.id}`);
      return ({
        data: json,
      });
    },

    // TODO: updateMany is not returning the records
    updateMany: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      console.log('updateMany', params);
      console.warn('Peter TODO preRequest');
      const { json } = await httpClient(`${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.ids.join(',')}`, {
        method: 'PUT',
        body: JSON.stringify(params.data),
      });
      return ({ data: json });
    },

    create: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      // console.log('create', resource, params);
      await preRequest(params);
      const { json } = await httpClient(`${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}`, {
        method: 'POST',
        body: JSON.stringify({
          ...params.data,
          // ...(params.data.user_id ? {} : {user_id: JSON.parse(localStorage.getItem('auth') as string).id}),
        }),
      });
      return ({
        data: { ...params.data, id: json },
      });
    },

    // TODO: delete is not returning the id
    delete: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      const { json } = await httpClient(`${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.id}`, {
        method: 'DELETE',
      });
      return ({ data: json });
    },

    deleteMany: async (resource, params) => {
      resource = RESOURCE_MAP[resource] ?.resource ?? resource;
      const { json } = await httpClient(`${apiUrl}/records/${process.env.REACT_APP_API_TABLE_PREFIX}${resource}/${params.ids.join(',')}`, {
        method: 'DELETE',
      });
      return ({ data: Array.isArray(json) ? json : [json] });
    },
  }

  return dp;
};

const preRequest = async (params: any) => {
  console.log('preRequest', params);
  await Promise.all(Object.entries(params.data).map(async ([key, field]: [string, any]) => {
    // console.log('all', key, field);
    if (field && field.rawFile && field.rawFile instanceof File) {
      params.data[key] = await convertFileToJson(field);
    } else if (Array.isArray(field) && field[0] && field[0].rawFile instanceof File) {
      params.data[key] = await Promise.all(field.map(async f => await convertFileToJson(f)));
    } else if (field instanceof Date) {
      params.data[key] = field.toISOString().replace('T', ' ').replace(/\.\d{3}Z/, '');
    } else if (field === '') {
      params.data[key] = null;
    }
  }));
}
const convertFileToJson = (paramDataFile: { rawFile: File }) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(paramDataFile.rawFile);

  reader.onload = () => resolve({
    ...paramDataFile,
    dataUrl: (reader.result as string),
  });
  reader.onerror = reject;
});

export default getDataProvider;
